<script setup>
import AppHeader from './components/layouts/AppHeader.vue'
import BottomNav from './components/layouts/BottomNav.vue'

import { onMounted, computed } from 'vue'

import { useAuthStore, useAppStore } from './stores'
const appStore = useAppStore();
const authStore = useAuthStore();
import {
    initCarousels,
    initCollapses,
    initDropdowns,
} from 'flowbite'

const authToken = localStorage.getItem('authToken')

if (authToken) {
    authStore.authToken = authToken
}

// initialize components based on data attribute selectors
onMounted(() => {
    initCollapses();
    initDropdowns();

})

const backgroundColor = computed(() => {
    return appStore.showAccountFeatures ? 'bg-gray-100' : 'bg-white' 
})

</script>

<template>
    <div :class="`${backgroundColor} border-gray-100 text-gray-500 flex flex-col h-dvh justify-stretch`">
        <AppHeader />
        <div :class="`flex-1 overflow-y-auto`">
            <div :style="`height: calc(100dvh - ${appStore.avaialableScreenHeight}`">
                <router-view></router-view>
            </div>
        </div>
        <BottomNav v-show="authStore.authToken" />
    </div>
</template>

<style scoped>
.logo {
    height: 6em;
    padding: 1.5em;
    will-change: filter;
    transition: filter 300ms;
}

.logo:hover {
    filter: drop-shadow(0 0 2em #646cffaa);
}

.logo.vue:hover {
    filter: drop-shadow(0 0 2em #42b883aa);
}
</style>
